import React, { useEffect, useState } from "react";
import ModalBox from "../../components/modal/ModalBox";
import NotFound from "../../components/not-found/NotFound";
import { Avatar, IconButton } from "@mui/material";
import { Button, SecondaryButton } from "../../components/Button/Button";
import {
  DatePicker,
  Select,
  capitalizeFirstLetter,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import { Link, useSearchParams } from "react-router-dom";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Switch from "../../components/Switch/Switch";
import { getuserListApi } from "../../services/userManagement";
import toast from "react-hot-toast";
import ChangeUserStatus from "./ChangeUserStatus";
import useButtonLoader from "../../hooks/UseButtonLoader";
import Person4Icon from "@mui/icons-material/Person4";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { AvatarImg } from "../../comman/avatar/Avatar";
import { ViewIcon } from "../../comman/action/ViewIcon";
import ImageModal from "../../comman/avatar/ImageModal";
import { DescriptionModal, ViewMore } from "../../comman/action/ViewMore";
import { PaginationShow } from "../../comman/action/Pagination";
import { setJwtToken } from "../../config/axiosInstance";
import axios from "axios";
const UserManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let plan = searchParam.get("plan") || "";
  let userTypeSearch = searchParam.get("userType") || "";
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";
  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [orderByName, setOrderByName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");
  const [userList, setUserList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [buttonref, buttonLoader] = useButtonLoader("Export as CSV");
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [showImgModal, setShowImgModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [userName, setUserName] = useState("");
  const [moreModal, setMoreModal] = useState(false);
  const [moreValue, setMoreValue] = useState("");
  const url = `${process.env.REACT_APP_API_URL}/admin/user/export_user`;
  const date = dateFormat(new Date());
  //----------see-more-in-modal----------
  const handleSeeMore = (email) => {
    setMoreModal(true);
    setMoreValue(email);
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, status, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
    setUserName(name);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setOrderByName("");
    setDirection("");
    setFieldName("");
    searchParam.delete("sortBy");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("status");
    searchParam.delete("plan");
    searchParam.delete("userType");
    setSearchParam(searchParam);
  };
  // //*********sorting product********* */
  const handlePlan = (event) => {
    searchParam.set("page", 1);
    searchParam.set("plan", event.target.value);
    setSearchParam(searchParam);
  };
  // //*********sorting product********* */
  const handleSelectUser = (event) => {
    searchParam.set("page", 1);
    searchParam.set("userType", event.target.value);
    setSearchParam(searchParam);
  };
  // // //*********start Date search********* */
  // const handleStartDate = (date) => {
  //     searchParam.set("page", 1)
  //     searchParam.set("startDate", searchDateFormat(date))
  //     setSearchParam(searchParam)
  // };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  // //*********status search********* */
  const statusHandler = (e) => {
    searchParam.set("page", 1);
    searchParam.set("status", e.target.value);
    setSearchParam(searchParam);
  };

  // ----------open-image-in-modal-full-page------------
  const openImage = (image) => {
    setShowImgModal(image ? true : false);
    setImageUrl(image);
  };

  //--------------sorting-name------------------------
  const orderByNameFun = () => {
    const newDirection = orderByName === "ASC" ? "DESC" : "ASC";
    setOrderByName(newDirection);
    setFieldName("name");
    setDirection(newDirection);
  };
  //------------------listing-Api----------------------------------
  const fatchUserList = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction,
    planType = plan,
    userType = userTypeSearch,
    startDate = searchStartDate,
    endDate = searchEndDate
  ) => {
    try {
      setUserList([]);
      showLoader();
      const res = await getuserListApi({
        page,
        search,
        sortField,
        sortDirection,
        planType,
        userType,
        startDate,
        endDate,
      });
      if (res.data.status === 200) {
        // console.log("communi", res?.data?.data?.total)
        setUserList(res?.data?.data?.Users || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setUserList([]);
        setTotal(0);
        hideLoader();
        toast.error(res?.data?.message);
      }
    } catch (e) {
      hideLoader();
      toast.error(e.message);
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!plan) {
      searchParam.delete("plan");
    }
    if (!userTypeSearch) {
      searchParam.delete("userType");
    }

    setSearchParam(searchParam);
    fatchUserList(
      activePage,
      debounceValue,
      fieldName,
      direction,
      plan,
      userTypeSearch
    );
  }, [searchParam, debounceValue, plan, userTypeSearch, fieldName, direction]);

  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      fatchUserList(
        activePage,
        debounceValue,
        fieldName,
        direction,
        plan,
        userTypeSearch,
        searchStartDate,
        searchEndDate
      );
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    setSearchParam(searchParam);
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);

  //---------------export-csv---------------------
  const downloadFile = async (url, fileName, params = {}) => {
    try {
      buttonLoader(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      buttonLoader(false);
    }
  };
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">User Management</h4>
            <button
              className="btn_size"
              ref={buttonref}
              onClick={() => downloadFile(url, `user_${date}`)}
            >
              Export as CSV
            </button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search name"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* --------select-plan---------- */}
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  plan === "" ? "text-secondary" : "text-dark"
                }`}
                value={plan}
                onChange={handlePlan}
              >
                <option value="">Select Plan</option>
                <option value="free">Free</option>
                <option value="premium plus">Premium plus</option>
                <option value="premium">Premium</option>

                <option value="basic">Basic</option>
              </Select>
            </div>
            {/* --------select-user-type---------- */}
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  userTypeSearch === "" ? "text-secondary" : "text-dark"
                }`}
                value={userTypeSearch}
                onChange={handleSelectUser}
              >
                <option value="">Select User Type</option>
                <option value="business">Business</option>
                <option value="individual">Individual</option>
                <option value="both">Both</option>
              </Select>
            </div>

            {/* <div className="form-group date_picker">
                            <DatePicker
                                className="form-control "
                                name="startDate"
                                selected={searchStartDate}
                                placeholder="Start Date"
                                onChange={(date) => handleStartDate(date)}
                                maxDate={searchEndDate}
                            />
                        </div> */}
            {/* <div className="form-group date_picker">
                            <DatePicker
                                name="endDate"
                                className="form-control"
                                placeholder="End Date"
                                selected={searchEndDate}
                                onChange={(date) => handleEndDate(date)}
                                minDate={searchStartDate}
                            />
                        </div> */}
            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Profile</th>
                  <th>
                    <div className="sorting-th" onClick={orderByNameFun}>
                      <span>Name</span>
                      {orderByName === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>User ID</th>
                  <th>User Type</th>
                  <th>Mobile number</th>
                  <th>Email</th>
                  <th>Plan</th>
                  <th>Created At</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>

              <tbody>
                {userList.length > 0 ? (
                  userList.map(
                    (
                      {
                        createdAt,
                        email,
                        id,
                        mobile,
                        name,
                        profile,
                        status,
                        _id,
                        userType,
                        plan,
                        userName,
                      },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>
                              <AvatarImg
                                id={_id}
                                image={profile}
                                openImage={openImage}
                              />
                            </td>
                            <td>{name.slice(0, 15) || "N/A"}</td>
                            <td>{userName || "N/A"}</td>
                            <td>{capitalizeFirstLetter(userType) || "N/A"}</td>
                            <td>{mobile || "N/A"}</td>
                            <td>
                              <ViewMore
                                value={email}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>{plan || "N/A"}</td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <Switch
                                  checked={status}
                                  onChange={() =>
                                    statusUpdateHandler(_id, status, name)
                                  }
                                />
                                <ViewIcon
                                  to={`/user-management/view-details/${_id}`}
                                />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No User Found!"
                    icon={<Person4Icon style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
        {/* --------show-img-from-api---------- */}
        <ImageModal
          showModal={showImgModal}
          closeModal={setShowImgModal}
          imageUrl={imageUrl}
          title="User Image"
        />
        {/* --------status-change---------- */}
        <ChangeUserStatus
          show={statusModal}
          close={() => setStatusModal(false)}
          id={statusId}
          userName={userName}
          status={statusValue}
          listing={fatchUserList}
        />
        {/* --------show-value-from-api---------- */}
        <DescriptionModal
          show={moreModal}
          close={() => setMoreModal(false)}
          value={moreValue}
          title="Email"
          fontSize="fs-5"
        />
      </div>
    </>
  );
};

export default UserManagement;
